<template>
  <div>
    <h1>{{ t('title') }}</h1>
    <p>{{ t('welcome') }}</p>
    <HomeView />
  </div>
</template>

<script setup lang="ts">
import HomeView from '@/views/HomeView.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

definePage({
  name: 'home',
  redirect: { name: 'dashboard' }
})
</script>

<i18n lang="yaml">
en:
  title: 'home'
  welcome: 'welcome to the home page'
nl:
  title: 'home'
  welcome: 'welkom op de home pagina'
de:
  title: 'home'
  welcome: 'willkommen auf der home seite'
</i18n>
